<template>
  <div class="activate-stats-page">
    <GlobalInfoBar title="已激活统计" subtitle="统计通过店员扫描IMEI激活的设备数据" />

    <div class="flow-note">
      <strong>数据来源说明：</strong>所有已激活记录均来自<strong>店员通过小程序扫描IMEI</strong>完成激活操作。系统记录激活时间、设备信息等完整数据。
    </div>

    <div class="stats-row">
      <div class="stat-card">
        <div class="label">今日激活</div>
        <div class="value green">{{ formatNumber(stats.today_count) }}</div>
        <div class="sub">店员扫码激活</div>
      </div>
      <div class="stat-card">
        <div class="label">本月累计激活</div>
        <div class="value blue">{{ formatNumber(stats.this_month_count) }}</div>
        <div class="sub">较上月 {{ stats.month_rate || '0%' }}</div>
      </div>
      <div class="stat-card">
        <div class="label">升级付费激活</div>
        <div class="value orange">{{ formatNumber(stats.upgrade_paid_count) }}</div>
        <div class="sub">占比 {{ stats.upgrade_rate || '0%' }}</div>
      </div>
      <div class="stat-card">
        <div class="label">免费激活</div>
        <div class="value purple">{{ formatNumber(stats.free_count) }}</div>
        <div class="sub">占比 {{ stats.free_rate || '0%' }}</div>
      </div>
    </div>

    <GlobalChunk title="激活明细" :padding="[20, 20, 20, 20]">
      <template slot="header">
        <el-button size="small" type="warning" @click="exportList">导出</el-button>
      </template>

      <GlobalForm
        ref="searchForm"
        :form-item-list="formItemList"
        :inline="true"
        confirmBtnName="搜索"
        @handleConfirm="query"
      >
        <div slot="AddBtn">
          <el-button size="small" type="info" round @click="clearSearch">重置</el-button>
        </div>
      </GlobalForm>

      <GlobalTable
        ref="GlobalTable"
        :columns="tableColumns"
        :data="tableData"
        :isIndex="false"
        :isPagination="true"
        :currentPage="curPage"
        :total="total"
        :pageSize="pageSize"
        @handleCurrentChange="currentChange"
      >
        <el-table-column slot="type" label="激活类型" align="center" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="isUpgradeActivate(row.type) ? 'warning' : 'success'" size="small">
              {{ getActivateTypeText(row.type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column slot="insuranceCost" label="保险成本价" align="center">
          <template slot-scope="{ row }">{{ formatPrice(row.insuranceCost) }}</template>
        </el-table-column>
        <el-table-column slot="dealerCost" label="经销商承担价" align="center">
          <template slot-scope="{ row }">{{ formatPrice(row.dealerCost) }}</template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from '@/utils/request'
import { activatedDownload, activatedList, shopNameList } from '@/utils/request'

export default {
  name: '已激活统计',
  data() {
    return {
      stats: {
        today_count: 0,
        this_month_count: 0,
        last_month_count: 0,
        month_rate: '0%',
        upgrade_paid_count: 0,
        free_count: 0,
        upgrade_rate: '0%',
        free_rate: '0%'
      },
      formItemList: [
        {
          key: 'date',
          type: 'date',
          labelName: '激活日期:',
          placeholder: '请选择激活日期',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          key: 'store',
          type: 'select',
          labelName: '门店:',
          placeholder: '全部门店',
          option: []
        },
        {
          key: 'imei',
          type: 'input',
          labelName: 'IMEI号:',
          placeholder: '搜索IMEI'
        },
        {
          key: 'type',
          type: 'select',
          labelName: '激活类型:',
          placeholder: '全部',
          option: [
            { label: '免费激活', value: '1' },
            { label: '升级付费激活', value: '2' }
          ]
        }
      ],
      tableColumns: [
        { prop: 'time', label: '激活时间' },
        { prop: 'imei', label: 'IMEI号' },
        { prop: 'model', label: '机型' },
        { prop: 'user', label: '用户姓名' },
        { prop: 'store', label: '门店' },
        { slotName: 'type' },
        { slotName: 'insuranceCost' },
        { slotName: 'dealerCost' },
        { prop: 'period', label: '生效期', width: 190 }
      ],
      tableData: [],
      curPage: 1,
      total: 0,
      pageSize: 20,
      searchParams: {}
    }
  },
  created() {
    this.fetchShopNameList()
    this.fetchStats()
    this.fetchList()
  },
  methods: {
    fetchShopNameList() {
      shopNameList().then(res => {
        const data = (res && res.data) || []
        const list = Array.isArray(data) ? data : (data.list || data.shopNameList || [])
        this.setSelectOptions('store', list)
      }).catch(() => {})
    },
    setSelectOptions(key, list = []) {
      const item = this.formItemList.find(formItem => formItem.key === key)
      if (!item) return
      item.option = list.map(option => {
        if (typeof option === 'string') {
          return { label: option, value: option }
        }
        const label = option.label || option.name || option.shop_name || option.shopName || option.store || option.store_name
        const value = option.value || option.id || option.shop_name || option.shopName || option.store || option.store_name || label
        return { label, value }
      }).filter(option => option.label !== undefined && option.value !== undefined)
    },
    query(params) {
      this.searchParams = { ...params }
      this.curPage = 1
      this.fetchList()
    },
    clearSearch() {
      this.$refs.searchForm.clear()
      this.searchParams = {}
      this.curPage = 1
      this.fetchList()
    },
    fetchStats() {
      _api.activateStats().then(res => {
        if (res && res.data) {
          this.stats = { ...this.stats, ...res.data }
        }
      }).catch(() => {})
    },
    buildListParams() {
      return {
        page: String(this.curPage),
        limit: String(this.pageSize),
        ...this.buildExportParams()
      }
    },
    buildExportParams() {
      return {
        date: this.searchParams.date || '',
        shop_name: this.searchParams.store || '',
        imei: this.searchParams.imei || '',
        exa_type: this.searchParams.type || ''
      }
    },
    fetchList() {
      activatedList(this.buildListParams()).then(res => {
        const data = (res && res.data) || []
        const list = Array.isArray(data) ? data : (data.list || [])
        this.tableData = list.map(this.normalizeActivatedRow)
        this.total = res.count || data.total || res.total || 0
      }).catch(() => {
        this.tableData = []
        this.total = 0
      })
    },
    formatNumber(value) {
      const number = Number(value)
      return Number.isNaN(number) ? value : number.toLocaleString()
    },
    normalizeActivatedRow(row) {
      return {
        ...row,
        time: this.formatEmpty(row.exa_time || row.add_time),
        imei: this.formatEmpty(row.imei),
        model: this.formatEmpty(row.model),
        user: this.formatEmpty(row.user_name || row.user || row.name),
        store: this.formatEmpty(row.shop_name),
        type: row.activate_type || row.exa_type || '',
        insuranceCost: row.cost_price,
        dealerCost: row.group_price,
        period: row.term_time_start && row.term_time_end ? `${row.term_time_start} ~ ${row.term_time_end}` : '--'
      }
    },
    formatEmpty(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') return '--'
      return `¥${value}`
    },
    isUpgradeActivate(type) {
      return String(type) === '2' || type === '升级付费激活'
    },
    getActivateTypeText(type) {
      if (String(type) === '1') return '免费激活'
      if (String(type) === '2') return '升级付费激活'
      return type || '-'
    },
    getMockData() {
      return [
        { time: '2026-06-08 14:32', imei: '862345678901234', model: 'Find X8 Pro', user: '张先生', store: '深圳南山旗舰店', type: 'paid', insuranceCost: 120, dealerCost: 80, period: '2026-06-08 ~ 2027-06-08' },
        { time: '2026-06-08 13:15', imei: '862345678905678', model: 'Reno 12 Pro', user: '李女士', store: '广州天河店', type: 'free', insuranceCost: 95, dealerCost: 60, period: '2026-06-08 ~ 2027-06-08' },
        { time: '2026-06-08 11:08', imei: '862345678909012', model: 'A3 Pro', user: '王先生', store: '深圳南山旗舰店', type: 'free', insuranceCost: 65, dealerCost: 40, period: '2026-06-08 ~ 2027-06-08' },
        { time: '2026-06-08 10:45', imei: '862345678903456', model: 'Find X8', user: '赵女士', store: '北京朝阳店', type: 'paid', insuranceCost: 110, dealerCost: 70, period: '2026-06-08 ~ 2027-06-08' }
      ]
    },
    exportList() {
      activatedDownload(this.buildExportParams()).then(res => {
        this.downloadFile(res, `激活明细_${+new Date()}.xls`)
      }).catch(() => {})
    },
    downloadFile(res, fileName) {
      const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    },
    currentChange(page) {
      this.curPage = page
      this.fetchList()
    }
  }
}
</script>

<style scoped lang="scss">
.activate-stats-page {
  .flow-note {
    margin-bottom: 16px;
    padding: 12px 16px;
    color: #595959;
    font-size: 13px;
    line-height: 1.8;
    background: #fff7e6;
    border-left: 4px solid #fa8c16;
    border-radius: 0 8px 8px 0;
  }

  .stats-row {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 20px;
  }

  .stat-card {
    padding: 18px 16px;
    text-align: center;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

    .label {
      color: #666;
      font-size: 12px;
    }

    .value {
      margin-top: 6px;
      font-size: 24px;
      font-weight: 700;
      line-height: 1.2;
    }

    .sub {
      margin-top: 6px;
      color: #999;
      font-size: 12px;
    }
  }

  .green {
    color: #52c41a;
  }

  .blue {
    color: #1890ff;
  }

  .orange {
    color: #fa8c16;
  }

  .purple {
    color: #722ed1;
  }
}
</style>
